import { StatsReportsIdsEnum } from '@empathybroker/tsclient-stats/dist/enums/stats-reports-ids.enum';
import { TermSuccessReportResponse } from '@empathybroker/tsclient-stats/dist/models/termsuccessreport/termsuccessreport-response';

import { ActionContext } from 'vuex';

import { ActionClass, AnalyticsState, ContextState, Pagination } from '../../../models';

import { CONTEXT_CONSTS } from '../../context/context.consts';
import { ANALYTICS_CONSTS } from '../analytics.consts';

export class LoadSearchDataAction implements ActionClass {

  public static async execute({ dispatch, commit, state, rootGetters }: ActionContext<AnalyticsState, any>,
    pagination: Pagination): Promise<TermSuccessReportResponse> {
    const context: ContextState = rootGetters[`${CONTEXT_CONSTS.moduleName}/${CONTEXT_CONSTS.getters.context}`];
    if (!!context.query) {
      let searchData = state.data.search[context.query];
      const offset = ((pagination.page - 1) * pagination.itemsPerPage);
      if (!searchData || ((searchData.params.rows !== pagination.itemsPerPage) || (searchData.params.offset !== offset))) {
        try {
          searchData = await dispatch(ANALYTICS_CONSTS.actions.fetchStatsReport, {
            id: StatsReportsIdsEnum.TERM_SUCCESS,
            params: {
              terms: context.query,
              rows: pagination.itemsPerPage,
              offset: offset
            }
          });
          commit(ANALYTICS_CONSTS.mutations.setSearchData, { data: searchData, query: context.query });
        } catch (error) {
          throw error;
        }
      }
      return searchData;
    }
  }

}
